export default __webpack_public_path__ + "static/media/IC00041-picture_edit_nofill.57dcd47f.svg";